import {
	Alert,
	Box,
	Button,
	Divider,
	Heading,
	Icons,
	Inline,
	Spinner,
	Stack,
	Text,
	useId,
} from "@sembark-travel/ui/base"
import { Dialog, useDialog } from "@sembark-travel/ui/dialog"
import { Markdown } from "@sembark-travel/ui/markdown"
import { PERMISSIONS, useCheckPermissions } from "../Auth"
import EditHotelBookingEnquiryEmailTemplate from "./EditHotelBookingEnquiryEmailTemplate"
import {
	IHotelBookingEnquiryEmailTemplateUpdate,
	IHotelBookingEnquiryEmailTemplateGet,
} from "./store"
import { useXHR } from "@sembark-travel/xhr"
import useSWR from "swr"

const HotelBookingEnquiryEmailTemplate = () => {
	const { hasPermission } = useCheckPermissions()
	const [isDialogOpen, openDialog, closeDialog] = useDialog()
	const xhr = useXHR()
	const { data, mutate } = useSWR("trip-hotel-booking-email-templates", () =>
		xhr
			.get<IHotelBookingEnquiryEmailTemplateGet>(
				"/trip-hotel-booking-email-templates"
			)
			.then((resp) => resp.data)
	)
	return (
		<Stack gap="4">
			<Inline justifyContent="between" gap="4" alignItems="center">
				<Inline gap="4" alignItems="center">
					<Inline
						size="12"
						rounded="full"
						bgColor="default"
						borderWidth="1"
						alignItems="center"
						justifyContent="center"
						color="muted"
						fontFamily="mono"
					>
						<Icons.Mail size="6" />
					</Inline>
					<Stack gap="1">
						<Heading as="h3">
							Hotel Booking Enquiry Email Template Configuration
						</Heading>
						<Text>
							These configuration will be applied to Hotel Booking Enquiry
							Email/WhatsApp Template only.
						</Text>
					</Stack>
				</Inline>
				{hasPermission(PERMISSIONS.MANAGE_USERS) ? (
					<Box>
						<Button onClick={openDialog} status="primary" size="sm">
							<Icons.Pencil /> Edit
						</Button>
					</Box>
				) : null}
			</Inline>
			<Divider marginY="0" />
			<Box>
				{!data?.data.length ? (
					<Box padding="4" bgColor="default" rounded="md" borderWidth="1">
						<Text>
							Using default hotel sharing email template configurations.
						</Text>
					</Box>
				) : (
					data.data.map((template) => (
						<Stack gap="4">
							<Stack gap="1">
								<Text fontWeight="semibold">Subject:</Text>
								<Box
									style={{
										textAlign: "justify",
									}}
									paddingX="4"
									paddingY="2"
									borderWidth="1"
									rounded="md"
									bgColor="default"
								>
									<Text>{template.subject_line}</Text>
								</Box>
							</Stack>

							<Stack gap="1">
								<Text fontWeight="semibold">Greetings:</Text>
								<Box
									style={{
										textAlign: "justify",
									}}
									paddingX="4"
									paddingY="2"
									borderWidth="1"
									rounded="md"
									bgColor="default"
								>
									<Markdown>{template.greetings}</Markdown>
								</Box>
							</Stack>
						</Stack>
					))
				)}
			</Box>
			<Dialog
				open={isDialogOpen}
				onClose={closeDialog}
				title="Update Email Template"
				lg
			>
				<Dialog.Body>
					<EditHotelEmailTemplate
						onCancel={() => {
							closeDialog()
						}}
						onSuccess={() => {
							closeDialog()
							mutate()
						}}
					/>
				</Dialog.Body>
			</Dialog>
		</Stack>
	)
}
export default HotelBookingEnquiryEmailTemplate

function EditHotelEmailTemplate({
	onCancel,
	onSuccess,
}: {
	onCancel: () => void
	onSuccess: () => void
}) {
	const xhr = useXHR()
	const id__ = useId()
	const { data, error } = useSWR(
		`/trip-hotel-booking-email-templates/update?${id__}`,
		() =>
			xhr
				.get<{
					data: IHotelBookingEnquiryEmailTemplateUpdate
				}>("/trip-hotel-booking-email-templates/create")
				.then((resp) => resp.data.data)
	)
	if (!data) {
		if (error) {
			return (
				<Alert status="error">
					{error.message || "Something went wrong. Please try after sometime."}
				</Alert>
			)
		}

		return <Spinner alignCenter padding="4" />
	}
	return (
		<Stack gap="4">
			<EditHotelBookingEnquiryEmailTemplate
				initialValues={data}
				onSubmit={() => {
					onSuccess()
				}}
				onCancel={onCancel}
			/>
		</Stack>
	)
}
